import standardsDictionary from '@widgets/agent-standards/i18n/ru/standards.dic.json';

export const standards = {
  STANDARDS: standardsDictionary,
};

export const standardsNamespaces = Object.keys(standards);
